import React, { useEffect, useState, useRef, } from 'react';
import Utils from '@nykaa/deals-utils/basic';
import { Swipeable } from 'react-swipeable';
import { Container, Grid, LeftArrowWrapper, List, RightArrowWrapper, Wrapper, } from './css';
import { LeftArrow, RightArrow } from '../SlidingWidgetV2/css';
import CONSTANTS from './constants';
import SectionHeader from '../SectionHeader';
import CategoryFilters from '../CategoryFilters';
const ProductV2 = (widgetData) => {
    const { params, children, isDesktop, cssStyle, trackingData, remoteConfigs, } = widgetData;
    const { title, description, appBkgColor, buttonData, isCategoryFilter, filterTags, } = params;
    const { categoryFiltersStyle, } = cssStyle;
    const { switches, } = remoteConfigs;
    const [transform, setTransform] = useState(0);
    const [scrollingWidth, setScrollingWidth] = useState(0);
    const [enableArrows, setEnableArrows] = useState(true);
    const listRef = useRef(null);
    const [selectedCategories, setSelectedCategories] = useState(['all']);
    const categoryFiltersTrackingData = Object.assign(Object.assign({}, trackingData), { widget_filters_all: Utils.arrayToObjectIndexFromOne(filterTags) });
    const leftArrowClick = () => {
        if (transform < 0) {
            setTransform(transform + CONSTANTS.SCROLL_OFFSET);
        }
    };
    const rightArrowClick = () => {
        if (transform > -scrollingWidth) {
            setTransform(transform - CONSTANTS.SCROLL_OFFSET);
        }
    };
    const handleSelected = (value) => {
        setSelectedCategories(value);
    };
    const isAllinFilterTags = selectedCategories.includes('all');
    const filteredProducts = children.filter(({ props }) => {
        const { params: { filterTags: tags }, } = props;
        const isFounded = tags.some((tag) => selectedCategories.includes(tag));
        return isFounded;
    });
    const renderChildrens = isAllinFilterTags ? children : filteredProducts;
    const childrenWithProps = React.Children.map(renderChildrens, (child, index) => {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, { childPosition: index });
        }
        return child;
    });
    useEffect(() => {
        const { scrollWidth, clientWidth, offsetWidth } = listRef === null || listRef === void 0 ? void 0 : listRef.current;
        const maxScrollWidth = (scrollWidth - clientWidth);
        setScrollingWidth(maxScrollWidth);
        setEnableArrows(scrollWidth > offsetWidth);
    }, [setEnableArrows, setScrollingWidth]);
    const { isEmptyWidget } = Utils;
    const checkEmptyWidget = isEmptyWidget(title, description, children, switches);
    return (React.createElement(Grid, { setEmptyWidget: checkEmptyWidget, appBkgColor: appBkgColor },
        React.createElement(Wrapper, { isDesktop: isDesktop },
            React.createElement("div", { className: "title-description" },
                React.createElement(SectionHeader, { isDesktop: isDesktop, cssStyle: cssStyle, title: title, description: description, buttonData: buttonData })),
            isCategoryFilter && (React.createElement("div", { className: "category-filters" },
                React.createElement(CategoryFilters, { styles: categoryFiltersStyle, filterTags: filterTags, handleSelected: handleSelected, isDesktop: isDesktop, trackingData: categoryFiltersTrackingData, remoteConfigs: remoteConfigs }))),
            React.createElement(Swipeable, { delta: 10, preventDefaultTouchmoveEvent: false, trackTouch: false, trackMouse: false, rotationAngle: 0, style: {
                    height: '90%',
                    position: 'relative',
                } },
                isDesktop && enableArrows && (React.createElement(LeftArrowWrapper, null,
                    React.createElement(LeftArrow, { onClick: leftArrowClick }))),
                React.createElement(List, { isDesktop: isDesktop, ref: listRef }, isDesktop ? (React.createElement(Container, { transform: transform }, childrenWithProps)) : (childrenWithProps)),
                isDesktop && enableArrows && (React.createElement(RightArrowWrapper, null,
                    React.createElement(RightArrow, { onClick: rightArrowClick })))))));
};
export default ProductV2;
